import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=26591cee&scoped=true&"
import script from "./classify.vue?vue&type=script&lang=js&"
export * from "./classify.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./classify.vue?vue&type=style&index=0&id=26591cee&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "26591cee",
  "0b4fc11c"
  
)

export default component.exports